export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (orgId?: string) => [...userKeys.lists(), orgId ?? 'all'] as const,
  platformTeam: () => [...userKeys.all, 'platform-team'] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  activity: (userId: string, limit?: number) =>
    [...userKeys.all, 'activity', userId, limit] as const,
}
